var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"e954718e8fa95fbeb001fcdbec4a4c8975a16f05"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["mawla-marketing@mawla"]={id:"e954718e8fa95fbeb001fcdbec4a4c8975a16f05"};
      